var React = require('react');

function Equals (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 336v32a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M448 144v32a32 32 0 0 1-32 32H32a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32h384a32 32 0 0 1 32 32z","className":"fa-primary","key":2})]);
}

Equals.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Equals;

Equals.default = Equals;
